/* eslint-disable jsx-a11y/aria-role */
import { useDrop } from 'react-dnd';

const CanDrop = ({ dropItem, index, children }) => {
  const [{ canDrop, isOver }, drop] = useDrop({
    accept: 'Box',
    drop: () => {
      return ({ name: 'Dustbin', dropItem });
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });
  const isActive = canDrop && isOver;
  let border = '2px dashed black';
  if (isActive) {
    border = '2px dashed red';
  } else if (canDrop) {
    border = '2px dashed green';
  }
  return (
    <div ref={drop} role="Dustbin" style={{ border }}>
      {children}
    </div>
  );
};

export default CanDrop;
